import { filter } from 'lodash-es'

/**
 * The documents uploaded for an element, i.e. the project files ("Dateien",
 * `projectFilesRootGuid`) linked to it.
 */
const getElementDocuments = (projectFiles: FileItem[], elementGuid: string): FileItem[] =>
  filter(projectFiles, file => file.element_guid === elementGuid)

export default getElementDocuments
